import theme from "../../../styles/theme"
import { ResponsiveBar } from "@nivo/bar"
import { useGetStaticItemSum } from "../../../interface/item";
import { ResponsivePie } from "@nivo/pie";
import { useEffect, useState } from "react";
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const ChartStaticItem = (param) => {

    const navigate = useNavigate();

    const {data: staticItemSum, isLoading: staticItemSumLoading} = useGetStaticItemSum();
    const [totItem, setTotItem] = useState([]);

    useEffect(()=>{
        if(staticItemSum){
            const filterTemp = staticItemSum.filter((item,index)=> item.pcid !== null && item.cid === null);
            const temp = filterTemp.map((item)=>(
                {"id":item.pcat_nm,
                "pcid":item.pcid,
                "archLabel":item.pcat_nm + ' ' + item.vtot_cnt + ' ( +' + item.m1_inc_cnt +' / -'+item.m1_dec_cnt+' )',
                "label":item.pcat_nm + ' ' + item.vtot_cnt + ' ( +' + item.m1_inc_cnt +' / -'+item.m1_dec_cnt+' )',
                "value": item.vtot_cnt}
            ))
            setTotItem(temp);
        }
    },[staticItemSum])

    return (
        <ResponsivePie
            data={totItem.reverse()}
            // sortByValue={true}
            margin={{ top: 20, right: 0, bottom: 10, left: -65 }}
            innerRadius={0.5}
            padAngle={1.5}
            startAngle={360}
            endAngle={0}
            cornerRadius={3}
            sortByValue={true}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        0.2
                    ]
                ]
            }}
            colors={{ scheme: 'nivo' }}
            arcLinkLabel={function(e){return e.data.archLabel}}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsStraightLength={12}
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        2
                    ]
                ]
            }}
            legends={[
                {
                    anchor: 'top-right',
                    direction: 'column',
                    justify: false,
                    translateX: -50,
                    translateY: 80,
                    itemsSpacing: 8,
                    itemWidth: 100,
                    itemHeight: 18,
                    itemTextColor: '#999',
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 18,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemTextColor: '#000'
                            }
                        }
                    ],
                    onClick:(datum,event)=>navigate('/admin/static/item?cid='+datum.data.pcid)
                }
            ]}
            tooltip={ToolTip}
            onClick={(node,event)=>navigate('/admin/static/item?cid='+node.data.pcid)}
        />
    )
}

const SubWrap = styled.div`
    background: #ffffff;
    padding: 6px;
    // border: 1px solid red;
    font-size: 1rem;
    line-height: 1.2rem;
    // color: ${(props)=>props.color};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const ToolTip = (param) => {

    return (
        <SubWrap>
            <svg width={15} height={15}>
                <rect x={0} y={0} fill={param.datum.color} width={15} height={15}/>
            </svg>&nbsp;
            {param.datum.label}
        </SubWrap>
    )

}

export default ChartStaticItem;